import { observable, action, runInAction } from 'mobx'
import { message } from 'antd'
import uuid from 'uuid/v4'
import { json } from '../../../../utils/ajax'
import { isAuthenticated } from '../../../../utils/Session'
import {setStore} from "../../../../utils/Utils";

class eAtlasContentStore {

    @observable carseries
    @observable loading
    @observable carSysId
    @observable directory
    @observable reviews
    @observable directoryId
    @observable conceal
    @observable contents
    @observable data
    @observable selectLanguageType//pdf中英文上传
    @observable defaultContentKey//右边展示pdf内容
    @observable contentLoading//右边展示文本内容
    @observable svgContents//右边展示svg内容
    @observable pdfContents//右边展示pdf内容
    @observable pdfContentsId//pdf上传后回显id
    @observable selectedRewData//左侧目录树点击行数据

    constructor () {
        this.carseries = []
        this.loading = false;
        this.carSysId = ''
        this.directory = []
        this.reviews = ''
        this.directoryId = ''
        this.conceal = ''
        this.contents = []
        this.data = 0
        this.selectLanguageType = 'zh'
        this.defaultContentKey='文本格式'
        this.contentLoading=false
        this.svgContents= []
        this.pdfContents= []
        this.pdfContentsId = ''
        this.selectedRewData = {}
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    @action
    resetData = () =>{
        runInAction(()=>{
            this.data = 0
        })
    }
    /**
     * 初始化车系
     */
    @action initCarseries = async() => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/carseriesCatalogs/list`)
        if(res && res.status === 0){
            return
        }
        runInAction(() => {
            this.carseries = res
            this.loading = false
        })
    }

    /**
     * 取车系ID
     */
    @action getCarSysId = (value) =>{
        runInAction(()=>{
            this.carSysId = value;
        })
    }

    /**
     * 目录树
     */
    @action
    initDirectory = async (value) => {
        runInAction(() => {
            this.contents = []
            this.loading = true
            this.directoryId = ''
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/list?carseriesId=${value}`)
        if (res.length === 0) {
            message.warning('该车系没有目录！')
            runInAction(() => {
                this.directory = [];
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.directory = res
            this.loading = false
        })
    }

    /**
     * 显示内容
     */
    @action
    loadContents = async () => {
        runInAction(() => {
            this.loading = true
            this.contents = []
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/selectLevel?id=${this.directoryId}`)
        if (res.status && res.status === 0) {
            return
        }
        runInAction(() => {
            this.data = res.data
        })
        if(res.data > 2){
            const review = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog:approvalState/${this.directoryId}`)
            runInAction(() => {
                if(review === 0){
                    this.reviews = '注意：当前无内容状态'
                }else if(review === 1){
                    this.reviews = '注意：当前草稿状态'
                }else if(review === 2){
                    this.reviews = '注意：当前待审状态'
                }else if(review === 3){
                    this.reviews = '注意：当前审批通过状态'
                }else if(review === 4){
                    this.reviews = '注意：当前审批驳回状态'
                }
            })
            const contents = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/content/searchOne?id=${this.directoryId}`)
            runInAction(() => {
                this.conceal = review
                this.contents = contents.length ? contents : [{
                        id: `${uuid()}`,
                        image: ' ',
                        defaultContent: '',
                        type: 1,
                        catalogId: this.directoryId
                    }]
                this.loading = false
            })}else{
            runInAction(() => {
                this.loading = false
            })
        }
    }

    /**
     * 保存内容
     */
    @action saveContents = async () => {
        if(this.contents.length === 0){
            message.warning('请选择内容！')
            return
        }
        runInAction(() => {
            this.loading = true
        })
        for (let i = 0; i < this.contents.length; i++) {
            let content = this.contents[i]
            if (!content.defaultContent.trim() && !content.image.trim()) {
                message.error('请填写完内容后保存！')
                runInAction(() => {
                    this.loading = false
                })
                return
            }
        }
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/content/save`,this.contents)
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/updateApprovalState/${this.directoryId}/1`)
        message.success('保存成功！')
        runInAction(() => {
            this.loading = false
        })
        this.loadContents()
    }

    /**
     * 上传图片
     */
    uploadImage = (blobInfo, success, failure) => {
        const formData = new FormData()
        formData.append('type', 'file')
        formData.append('file', blobInfo.blob())
        fetch(`${process.env.REACT_APP_API_URL}/onestep/base/upload`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'x-access-token': isAuthenticated(),
            },
            body: formData
        }).then(response => {
            return response.text()
        }).then(text => {
            success(text)
        })
    }

    /**
     * 送审
     */
    @action review = async () => {
        runInAction(() => {
            this.loading = true
        })
        //查询审批状态
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog:approvalState/${this.directoryId}`)
        if (res === 1 || res === 4) {
            const data = {
                'approvalOption': 0,
                'catalogId': this.directoryId
            }
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/approval`,data)
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/updateApprovalState/${this.directoryId}/2`)
            message.success('送审成功')
            runInAction(() => {
                this.loading = false
            })
        } else if (res === 2) {
            message.error('内容待审中，请勿再次送审')
            runInAction(() => {
                this.loading = false
            })
        } else if (res === 3) {
            message.error('内容审批已通过，请勿再次送审')
            runInAction(() => {
                this.loading = false
            })
        } else {
            message.error('请保存内容后再送审')
            runInAction(() => {
                this.loading = false
                return
            })
        }
        this.loadContents()
    }

    /**
     * 初始化页面
     */
    @action emptyPage = () =>{
        runInAction(() => {
            this.contents = []
            this.directory = []
        })
    }

    /**
     * 获取到目录树ID
     */
    @action stlcontent = (directoryId) =>{
        this.directoryId = directoryId.id
    }

    /**
     * 获取到每个小节内容和ID
     */
    @action changeContentTitle = (id, value) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (id === item.id) {
                    return {...item, title: value}
                }
                return item
            })
        })
    }

    /**
     * 获取到每个编辑器的内容和ID
     */
    @action setContent = (id, value) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === id) {
                    return {...item, defaultContent: value}
                }
                return item
            })
        })
    }

    /**
     * 删除编辑框里的图片
     */
    @action delImage = (contentId, imageIndex) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === contentId) {
                    return {...item, image: item.image.trim().split(',').filter((img, index) => index !== imageIndex).join(',')}
                }
                return item
            })
        })
    }

    /**
     * 获取到左图右文的内容和ID
     */
    @action addContent = (id, type) => {
        const contents = []
        this.contents.forEach(item => {
            contents.push(item)
            if (item.id === id) {
                contents.push({
                    id: `${uuid()}`,
                    image: '',
                    defaultContent: '',
                    type: type * 1,
                    catalogId: this.directoryId
                })
            }
        })
        runInAction(() => {
            this.contents = contents
        })
    }

    /**
     * 获取到右图左文的内容和ID
     */
    @action addContent = (id, type) => {
        const contents = []
        this.contents.forEach(item => {
            contents.push(item)
            if (item.id === id) {
                contents.push({
                    id: `${uuid()}`,
                    image: '',
                    defaultContent: '',
                    type: type * 1,
                    catalogId: this.directoryId
                })
            }
        })
        runInAction(() => {
            this.contents = contents
        })
    }

    /**
     * 删除编辑框里的内容
     */
    @action delContent = (id) => {
        const contents = this.contents.filter(item => item.id !== id)
        runInAction(() => {
            this.contents = contents.length > 0 ? contents : [{
                    id: `${uuid()}`,
                    image: '',
                    defaultContent: '',
                    type: 1,
                    catalogId: this.directoryId
                }]
        })
    }

    /**
     * 添加图片
     */
    @action addImage = (id, url) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === id) {
                    return {...item, image: item.image.trim().length > 0 ? `${item.image},${url}` : url}
                }
                return item
            })
        })
    }

    /**
     * 获取ID 用于上移编辑框
     */
    @action contentUp = (id) => {
        const index = this.contents.findIndex(item => item.id === id)
        if (index > 0) {
            runInAction(() => {
                this.contents = this.swapItems(this.contents, index, index - 1)
            })
        }
    }

    /**
     * 获取ID 用于下移编辑框
     */
    @action contentDown = (id) => {
        const index = this.contents.findIndex(item => item.id === id)
        if(index+1 === this.contents.length){
            return
        }
        if (index >= 0 && index < this.contents.length) {
            runInAction(() => {
                this.contents = this.swapItems(this.contents, index, index + 1)
            })
        }
    }

    swapItems = (arr, index1, index2) => {
        arr[index1] = arr.splice(index2, 1, arr[index1])[0]
        return arr
    }


    /**
     * 切换pdf或文本格式
     * @param key
     * @returns {Promise<void>}
     */
    @action
    changeKey=async (key)=>{
        this.defaultContentKey=key
        if(key==='文本格式'){
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/selectLevel?id=${this.directoryId}`)
            if (res.status && res.status === 0) {
                return
            }
            runInAction(() => {
                this.data = res.data
            })
        }else if(key==='PDF'){
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/contentPdfAddress/catalogId/${this.directoryId}`)
            if (res.status && res.status === 0) {
                return
            }
            runInAction(() => {
                this.pdfContents = [res]
                this.pdfContentsId = res.id
            })
        }
    }

    /***
     * PDF上传
     * @param info
     */
    @action
    pdfUpload=async (info)=>{
        this.loading=true
        let obj={
            pdfName:info.file.name,
            pdfUrl:info.file.response,
            catalogId:this.directoryId,
            id:this.pdfContentsId
        }
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/contentPdfAddress/insert`,obj)
        runInAction(()=>{
            this.loading=false
            this.changeKey('PDF')
        })
    }

    @action
    deletePdf=async ()=>{
        this.loading=true
        let res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/contentPdfAddress/delete/${this.directoryId}`)
        if(res.status){
            message.success(`删除成功！`)
        }
        runInAction(()=>{
            this.loading=false
            this.changeKey('PDF')
        })

    }
}
export default new eAtlasContentStore()



// WEBPACK FOOTER //
// ./src/Backend/dongfeng/EAtlas/EAtlasContent/store.js